import React from 'react';

const MobilePDFViewer = ({ pdfUrl, onError }) => {
  
  return (
    <div className="flex flex-col h-full">
      {/* Apenas botão para abrir PDF completo */}
      <div className="flex items-center justify-center p-3 bg-gray-50 border-b">
        <button
          onClick={async () => {
            try {
              // Detectar se está rodando como app nativo
              if (window.Capacitor) {
                // App nativo - usar Capacitor Browser
                const { Browser } = await import('@capacitor/browser');
                await Browser.open({ 
                  url: pdfUrl,
                  windowName: '_system'
                });
              } else {
                // Web browser - usar target blank
                window.open(pdfUrl, '_blank', 'noopener,noreferrer');
              }
            } catch (error) {
              console.error('Erro ao abrir PDF:', error);
              // Fallback para web
              window.open(pdfUrl, '_blank', 'noopener,noreferrer');
            }
          }}
          className="px-4 py-3 bg-green-500 hover:bg-green-600 text-white rounded-lg text-sm font-medium flex items-center gap-2"
        >
          📱 Abrir PDF Completo
        </button>
      </div>

      {/* Object tag - melhor para iOS Safari */}
      <div className="flex-1 overflow-auto">
        <object
          data={pdfUrl}
          type="application/pdf"
          className="w-full h-full"
          style={{ 
            width: '100%',
            height: '100%',
            minHeight: '400px'
          }}
        >
          {/* Fallback para quando object não funciona */}
          <iframe
            src={pdfUrl}
            className="w-full h-full border-0"
            title="PDF Viewer Fallback"
            style={{ 
              width: '100%',
              height: '100%',
              minHeight: '400px'
            }}
          />
        </object>
      </div>
    </div>
  );
};

export default MobilePDFViewer;